import { TT_URL } from "@/common/constants";
import axios from "axios";

import { getCookie, isEmptyString } from "@/common/utils";

export function getDaysSince1900(dateAsNumber) {
  let year = Math.round(dateAsNumber / 10000);
  let rest = dateAsNumber % 10000;
  let month = Math.round(rest / 100);
  let day = rest % 100;

  let date = new Date(year, month - 1, day, 12, 0, 0, 0);
  let refDate = new Date(1900, 0, 1, 12, 0, 0, 0);
  let days =
    Math.round(date.getTime() / 24 / 3600000) -
    Math.round(refDate.getTime() / 24 / 3600000);

  return days + 2; // Excel error 29.2.1900 exists only in Excel
}

export function getMonth(dateAsNumber) {
  return Math.round((dateAsNumber % 10000) / 100);
}

export function getDateFromTimestamp(ts) {
  let y = ts.getFullYear();
  let m = ts.getMonth() + 1;
  let d = ts.getDate();

  return parseInt(y + (m < 10 ? "0" : "") + m + (d < 10 ? "0" : "") + d, 10);
}

export function getDateFromSeconds(seconds) {
  let ts = getTimestampFromSeconds(seconds);
  return getDateFromTimestamp(ts);
}

export function getYearFromTimestamp(ts) {
  return ts.getFullYear();
}

export function getSecondsFromTimestamp(ts) {
  return Math.round(ts.getTime() / 1000);
}

export function getTimestampFromSeconds(seconds) {
  return new Date(seconds * 1000);
}

export function getTimeFromSeconds(seconds) {
  return getTimestampFromSeconds(seconds)
    .toTimeString()
    .substring(0, 8);
}

export function formatSecondsAsWorkTime(seconds) {
  let m = Math.floor(seconds / 60) % 60;
  let h = Math.floor(seconds / 3600);
  let s = seconds % 60;
  return seconds == 0
    ? "--:--:--"
    : h + ":" + (m < 10 ? "0" : "") + m + ":" + (s < 10 ? "0" : "") + s;
}

export function formatNumberAsDate(date) {
  if (date == null || date == 0) {
    return "";
  }
  let s = date.toString();
  let y = s.substring(0, 4);
  let m = s.substring(4, 6);
  let d = s.substring(6, 8);

  return d + "." + m + "." + y;
}

export function getDate(seconds) {
  let m = Math.floor(seconds / 60) % 60;
  let h = Math.floor(seconds / 3600);
  let s = seconds % 60;
  return seconds == 0
    ? "--:--:--"
    : " [" +
        h +
        ":" +
        (m < 10 ? "0" : "") +
        m +
        ":" +
        (s < 10 ? "0" : "") +
        s +
        "]";
}

export function newYearTracking() {
  return {
    dateOfLastStamp: null,
    numberOfSecondsToday: 0,
    lastStartStampTimestampToday: 0, // if >0 then started
    workingDays: []
  };
}

export function newWorkingDay(date) {
  return {
    date: date,
    numberOfSeconds: 0,
    stopped: true,
    trackingItems: []
  };
}

export function newTrackingItem(timeInSeconds, stopped, servicekleber, tasks) {
  return {
    timestamp: timeInSeconds,
    stopped: stopped,
    id: servicekleber.tib.id,
    extRef: servicekleber.data.extRef,
    name: servicekleber.tib.name,
    tasks: tasks
  };
}

export function searchTibByPath(tibs, path) {
  for (let i = 0; i < tibs.length; i++) {
    var tib = tibs[i];
    if (tib.path === path) {
      return tib;
    }
  }

  return null;
}

export function loadOrCreateTrackingTib(tibs, email, ts) {
  let year = getYearFromTimestamp(ts);
  let tib = searchTibByPath(tibs, "/timetracking/users/" + email + "/" + year);

  if (tib === null) {
    // TODO neue Jahre sollten von einem Admin angelegt werden!
    //finishLastYearIfAny();
    // eslint-disable-next-line
    tib = createPublicYearTib();
    tibs.push(tib);
  }

  return tib;
}

export function getTrackingSecondsToday(tib) {
  if (tib == null) {
    return 0;
  }
  let now = new Date();
  let tracking = JSON.parse(tib.data);
  let ret = 0;

  if (tracking.dateOfLastStamp === getDateFromTimestamp(now)) {
    ret = tracking.numberOfSecondsToday;
    if (tracking.lastStartStampTimestampToday > 0) {
      ret =
        ret +
        getSecondsFromTimestamp(now) -
        tracking.lastStartStampTimestampToday;
    }
  }

  return ret;
}

export function createNewWorkingDay(tracking, date) {
  if (tracking.workingDays.length > 0) {
    tracking.workingDays[tracking.workingDays.length - 1].stopped =
      tracking.lastStartStampTimestampToday == 0;
    tracking.numberOfSecondsToday = 0;
    tracking.lastStartStampTimestampToday = 0;
  }
  let workingDay = newWorkingDay(date);
  tracking.workingDays.push(workingDay);

  return workingDay;
}

export function getOrCreateWorkingDay(date, tracking) {
  if (tracking.dateOfLastStamp !== date) {
    tracking.dateOfLastStamp = date;
    return createNewWorkingDay(tracking, date);
  }

  return tracking.workingDays[tracking.workingDays.length - 1];
}

export function getLastWorkingDay(tracking) {
  if (
    tracking.dateOfLastStamp === getDateFromTimestamp(new Date()) &&
    tracking.workingDays.length > 0
  ) {
    return tracking.workingDays[tracking.workingDays.length - 1];
  }

  return null;
}

export function getLastActiveTasksFromServicekleber(workingDay, id) {
  let activeTasks = [];

  if (workingDay != null && workingDay.trackingItems.length > 0) {
    for (let i = workingDay.trackingItems.length - 1; i >= 0; --i) {
      let trackingItem = workingDay.trackingItems[i];

      if (trackingItem.id === id) {
        activeTasks = trackingItem.tasks;
        break;
      }
    }
  }

  return activeTasks;
}

//todo move to separate js script (Schoch)
export function addTask(tasks, day, task) {
  if (!isEmptyString(task)) {
    tasks.push({ id: day, de: day + ": " + task });
  }
}

//todo move to separate js script (Schoch)
export function loadAnlagenTasksFromProperties(
  settingsTib,
  properties,
  settings
) {
  settings.tasksPerExtRef = {};

  for (let propertiesEntry of properties) {
    let extRef = propertiesEntry[settings.propertiesForeignKey];
    if (!isEmptyString(extRef)) {
      let tasks = [];
      addTask(tasks, "Mo", propertiesEntry.Zusatzfelder.Z_Operating_Montag);
      addTask(tasks, "Di", propertiesEntry.Zusatzfelder.Z_Operating_Dienstag);
      addTask(tasks, "Mi", propertiesEntry.Zusatzfelder.Z_Operating_Mittwoch);
      addTask(tasks, "Do", propertiesEntry.Zusatzfelder.Z_Operating_Donnerstag);
      addTask(tasks, "Fr", propertiesEntry.Zusatzfelder.Z_Operating_Freitag);
      settings.tasksPerExtRef[extRef] = tasks;
    }
  }
  settingsTib.data = JSON.stringify(settings);
  axios
    .post(TT_URL + "/api/rest/tibtix/updateTib", settingsTib)
    // eslint-disable-next-line
    .then(response => {
      console.info("settings saved");
      alert(
        "Einstellungen erfolgreich von Proffix gelesen und in TiBTiX gespeichert"
      );
    })
    .catch(function(error) {
      alert("An error has occurred." + "\n" + error);
    });
}

//todo move to separate js script (Schoch)
export function loadAnlagenFromProperties(
  propertiesTib,
  settingsTib,
  properties,
  settings
) {
  propertiesTib.data = JSON.stringify(properties);

  axios
    .post(TT_URL + "/api/rest/tibtix/updateTib", propertiesTib)
    // eslint-disable-next-line
    .then(response => {
      console.info("properties saved");
      loadAnlagenTasksFromProperties(settingsTib, properties, settings);
    })
    .catch(function(error) {
      alert("An error has occurred." + "\n" + error);
    });
}

//todo move to separate js script (Schoch)
export function loadAnlagen(
  propertiesTib,
  settingsTib,
  properties,
  settings,
  pxsessionid
) {
  axios
    .get(//https://proffix.sg-schoch.ch:51000
      "/pxapi/v3/BAS/Anlage?depth=3&limit=-1&fields=AnlageNrBAS,Bezeichnung,ErstelltAm,GeaendertAm,Zusatzfelder",
      {
        headers: {
          PxSessionId: pxsessionid
        }
      }
    )
    .then(response => {
      loadAnlagenFromProperties(
        propertiesTib,
        settingsTib,
        response.data,
        settings
      );
    })
    .catch(function(error) {
      alert("An error has occurred." + "\n" + error);
    });
}

//todo move to separate js script (Schoch)
export function loadTasks(propertiesTib, settingsTib, properties, settings) {
  // access properties from Schoch REST API
  let payload = {
    Benutzer: "NEXI",
    Passwort:
      "E82FD7416A19FF8A2E9523B1850F5ECD90967650FB8238F978A531522BF97187",
    Datenbank: { Name: "PXSCHOCHVENDING" },
    Module: []
  };

  axios //https://proffix.sg-schoch.ch:51000
    .post("/pxapi/v3/PRO/Login", payload)
    .then(response => {
      loadAnlagen(
        propertiesTib,
        settingsTib,
        properties,
        settings,
        response.headers.pxsessionid
      );
    })
    .catch(function(error) {
      alert("An error has occurred." + "\n" + error);
    });
}

export function generateExcelSheet(templateUrl, year, username, timetracking) {
  let path = "/timetracking/" + year + "/" + username;
  let name = getDateFromTimestamp(new Date()) + "-" + username + ".xlsx";
  let description =
    "Generierte Datei:\n" +
    new Date().toISOString() +
    " - " +
    getCookie("lastusername");

  let sheetRohdaten = {
    sheetName: "Rohdaten",
    keys: ["Datum", "Zeitstempel", "Zeit", "Stop", "AnlageNr", "Arbeiten"],
    types: [
      "java.lang.Integer",
      "java.lang.Integer",
      "java.lang.String",
      "java.lang.String",
      "java.lang.Boolean",
      "java.lang.String"
    ],
    data: []
  };

  let sheetArbeitszeit = {
    sheetName: "Arbeitszeit",
    keys: ["Datum", "Sekunden", "Stop", "Korrigiert"],
    types: [
      "java.lang.Integer",
      "java.lang.Integer",
      "java.lang.Boolean",
      "java.lang.String"
    ],
    data: []
  };

  let sheetMonate = {
    sheetName: "Monate",
    keys: ["Monat", "Sekunden", "Arbeitszeit", "Stunden"],
    types: [
      "java.lang.String",
      "java.lang.Integer",
      "java.lang.String",
      "java.lang.Double"
    ],
    data: []
  };

  let months = [
    "Sum",
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez"
  ];
  let secondsPerMonth = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  for (const workingDay of timetracking.workingDays) {
    let month = getMonth(workingDay.date);
    let daysSince1900 = getDaysSince1900(workingDay.date);
    sheetArbeitszeit.data.push({
      Datum: daysSince1900,
      Sekunden: workingDay.numberOfSeconds,
      Stop: workingDay.stopped,
      Korrigiert: workingDay.corrected != null ? workingDay.corrected : ""
    });
    secondsPerMonth[0] += workingDay.numberOfSeconds;
    secondsPerMonth[month] += workingDay.numberOfSeconds;

    for (const trackingItem of workingDay.trackingItems) {
      sheetRohdaten.data.push({
        Datum: daysSince1900,
        Zeitstempel: trackingItem.timestamp,
        Zeit: getTimeFromSeconds(trackingItem.timestamp),
        Stop: trackingItem.stopped,
        AnlageNr: trackingItem.extRef,
        Arbeiten: trackingItem.tasks.toString()
      });
    }
  }

  for (let i = 0; i < secondsPerMonth.length; ++i) {
    sheetMonate.data.push({
      Monat: months[i],
      Sekunden: secondsPerMonth[i],
      Arbeitszeit: formatSecondsAsWorkTime(secondsPerMonth[i]),
      Stunden: secondsPerMonth[i] / 3600.0
    });
  }

  axios
    .post(TT_URL + "/api/upload/excelfromtemplate", {
      templateUrl: templateUrl,
      name: name,
      description: description,
      folder: path,
      templateSheetDataList: [sheetMonate, sheetArbeitszeit, sheetRohdaten]
    })
    .then(response => {
      window.location.href = response.data.url;
    })
    .catch(function(error) {
      alert("error", "An error has occurred." + "\n" + error);
    });
}

// eslint-disable-next-line
export function geo_success(position) {
  alert("pos=" + position.coords.latitude + "," + position.coords.longitude);
}

// eslint-disable-next-line
export function geo_error() {
  alert("Entschuldigung, keine Positionsinformationen sind verfügbar.");
}

// eslint-disable-next-line
var geo_options = {
  enableHighAccuracy: true,
  maximumAge: 10000,
  timeout: 10000
};

// TODO var wpid = navigator.geolocation.getCurrentPosition(geo_success, geo_error, geo_options);

export function addTimestamp(
  workingDay,
  timeInSeconds,
  stopped,
  servicekleber,
  tasks
) {
  let trackingItem = newTrackingItem(
    timeInSeconds,
    stopped,
    servicekleber,
    tasks
  );

  workingDay.trackingItems.push(trackingItem);
  return trackingItem;
}

export function evalTasksFromSettings(flags, settings) {
  let tasks = [];

  for (let tasksPerType of settings.tasksPerType) {
    if (flags.indexOf(tasksPerType.type) >= 0) {
      for (let task of tasksPerType.tasks) {
        tasks.push(task);
      }
    }
  }

  return tasks;
}

export function addTrackingStampToTib(
  timeInSeconds,
  tib,
  stop,
  servicekleber,
  tasks
) {
  let tracking = JSON.parse(tib.data);
  let date = getDateFromSeconds(timeInSeconds);
  let workingDay = getOrCreateWorkingDay(date, tracking);
  let trackingItem = null;

  if (stop) {
    if (tracking.lastStartStampTimestampToday > 0) {
      tracking.numberOfSecondsToday =
        tracking.numberOfSecondsToday +
        timeInSeconds -
        tracking.lastStartStampTimestampToday;
      workingDay.numberOfSeconds = tracking.numberOfSecondsToday;
      tracking.lastStartStampTimestampToday = 0;
      trackingItem = addTimestamp(
        workingDay,
        timeInSeconds,
        true,
        servicekleber,
        tasks
      );
    } else {
      // error already stopped
    }
  } else {
    if (tracking.lastStartStampTimestampToday == 0) {
      tracking.lastStartStampTimestampToday = timeInSeconds;
    }
    trackingItem = addTimestamp(
      workingDay,
      timeInSeconds,
      false,
      servicekleber,
      tasks
    );
  }

  tib.data = JSON.stringify(tracking);

  return trackingItem;
}
